"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderCC = void 0;
class GetOrderCC {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getOrderCC(request);
    }
}
exports.GetOrderCC = GetOrderCC;
